module.exports = {
  fr: {
    path: 'fr',
    locale: 'Francais',
    default: true
  },
  en: {
    path: 'en',
    locale: 'English'
  }
}



// WEBPACK FOOTER //
// ./src/constants/locales.js